import restClient from "../restClient";

export const getPortfolios = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`portfolios`,config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getPortfolioDetail = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`portfolios/${id}`,config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createPortfolios = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.post(`portfolios`, {data: data}, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updatePortfolio = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.put(`portfolios/${id}`, {data: data}, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deletePortfolio = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`portfolios/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
